import { Flatfile } from "@flatfile/api";

export const feedbackSheet: Flatfile.SheetConfig = {
  name: "Feedback",
  slug: "feedback",
  fields: [
    {
      key: 'affectedCustomerEmail',
      type: 'string',
      label: 'email address',
      constraints: [{ type: 'required' },
      ],
    },
    {
      key: 'content',
      type: 'string',
      label: 'feedback content',
      constraints: [{ type: 'required' }],
    },
    {
      key: 'createdAt',
      type: 'string',
      label: 'created date (yyyy-mm-dd)',
      description: 'Must be either a simple date (ex: 2023-01-01) or in the ISO8601 date format (ex: 2023-01-01T12:10:00Z).',
    },
    {
      key: 'importance',
      type: 'enum-list',
      label: 'importance',
      config: {
        options: [
          { value: 'low', label: 'Low' },
          { value: 'medium', label: 'Medium' },
          { value: 'high', label: 'High' },
        ],
      }
    },
    {
      label: 'reaction',
      key: 'reaction',
      type: 'enum-list',
      config: {
        options: [
          { value: 'sad', label: 'Sad' },
          { value: 'meh', label: 'Meh' },
          { value: 'happy', label: 'Happy' },
        ],
      }
    },
    {
      key: 'reporterEmail',
      type: 'string',
      label: 'reporter email',
      description: 'The person within your organization that recorded the feedback.',
    },
    {
      key: 'internalNote',
      type: 'string',
      label: 'internal note',
    },
    {
      key: 'ideaName',
      type: 'string',
      label: 'idea name',
      description: 'This will either match to an existing Idea, or create a new one if none exists.',
    },
    {
      key: 'ideaNotes',
      type: 'string',
      label: 'idea content',
      description: 'If an existing Idea matching the Idea name exists, this will overwrite the existing Idea content.',
    },
    {
      key: 'ideaCategories',
      type: 'string',
      label: 'idea categories',
      description: 'A comma separated list of categories.',
    },
    {
      key: 'ideaCreatedAt',
      type: 'string',
      label: 'idea date created (yyyy-mm-dd)',
      description: 'If an existing Idea matching the Idea name exists, this will overwrite the existing Idea created date.',
    },
    {
      key: 'ideaPublished',
      type: 'enum-list',
      label: 'idea published (yes, no)',
      description: 'If the idea should be set as published or not',
      config: {
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
      }
    },
  ],
};